import api from './index'

// 根据城市获取门店开始结束时间
export const getChooseTime = (params) => api.post('/v2/subscription/action/getChooseTime', params)

// 根据城市及订阅类型查询配置的相关车型
export const queryCarModelByCity = (params) => api.post('/carModel/action/queryCarModelByCity', params)

// 查询全部配置的相关车型
export const queryEnableCarModel = (params) => api.post('/carModel/action/queryEnableCarModel', params)

// 新增线索(用车页提交)
export const sublead = (params) => api.post('/sublead/', params)
